import { useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { getBaseUrl } from "../../../../../Redux/Config/AppConfig";
import axios from "axios";

function HotelInvoice() {
  const location = useLocation();
  const componentRef = useRef();
  const invoiceData = location.state?.paymentInvoice;
  const baseUrl = getBaseUrl();
  const [hotelDetails, setHotelDetails] = useState(null);
  const {
    invoice_number,
    invoice_date,
    due_date,
    total_amount,
    subtotal,
    tax_amount,
    discount_amount,
    paid_amount,
    balance_amount,
    status,
    reservation,
    guest_id,
    notes,
    email_sent,
    email_sent_at,
  } = invoiceData;
  const { first_name,last_name,phone  }=location.state?.paymentInvoice?.guests
  const hotelId = location.state?.paymentInvoice?.reservation?.hotel_id;

  let token = localStorage.getItem('token')

  useEffect(() => {
    const fetchHotelDetails = async () => {
      if (!hotelId) return;

      try {
        const response = await fetch(`${baseUrl}/hotel/${hotelId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch hotel details");
        }

        const result = await response.json();
        setHotelDetails(result?.data);
      } catch (error) {
        console.error("Error fetching hotel details:", error);
      }
    };

    fetchHotelDetails();
  }, [hotelId, baseUrl, token]);


  if (!invoiceData) {
    return (
      <div className="container py-5 text-center">
        <h5>No invoice data found.</h5>
      </div>
    );
  }


  const formattedDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

  const formattedDateTime = (date) =>
    new Date(date).toLocaleString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });

  const downloadInvoice = async () => {
    const resp = await fetch(
      `${baseUrl}/billing/invoices/${invoiceData?.id}/pdf`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/pdf",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    const blob = await resp.blob();

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "file.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const calculateNights = (checkIn, checkOut) => {
    const checkInDate = new Date(checkIn);
    const checkOutDate = new Date(checkOut);
    const timeDiff = checkOutDate.getTime() - checkInDate.getTime();
    return Math.ceil(timeDiff / (1000 * 3600 * 24));
  };

  const nights = calculateNights(
    reservation.check_in_date_time,
    reservation.check_out_date_time
  );



  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case "paid":
        return "#28a745";
      case "partially_paid":
        return "#ffc107";
      case "unpaid":
        return "#dc3545";
      default:
        return "#6c757d";
    }
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4 no-print">
        <h2>Invoice</h2>
        {/* <button className="btn btn-outline-secondary" onClick={downloadInvoice}>
          🖨️ Download
        </button> */}
      </div>

      {/* Invoice Content */}
      <div
        ref={componentRef}
        className="invoice-container"
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          backgroundColor: "white",
          padding: "40px",
        }}
      >
        {/* Header */}
        <div
          className="invoice-header"
          style={{ fontSize: "28px", fontWeight: "bold", marginBottom: "30px" }}
        >
          HOTEL INVOICE
        </div>

        {/* Invoice Details and Status */}
        <div
          className="d-flex justify-content-between align-items-start"
          style={{ marginBottom: "20px" }}
        >
          <div style={{ fontSize: "14px", lineHeight: "1.6" }}>
            <div>
              <strong>Invoice #:</strong> {invoice_number}
            </div>
            <div>
              <strong>Date:</strong> {formattedDate(invoice_date)}
            </div>
            <div>
              <strong>Due Date:</strong> {formattedDate(due_date)}
            </div>
            <div>
              <strong>Booking ID:</strong> {reservation.booking_id}
            </div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div
              className="status-badge"
              style={{
                display: "inline-block",
                padding: "6px 12px",
                borderRadius: "4px",
                backgroundColor: getStatusColor(status),
                color: "white",
                fontSize: "12px",
                fontWeight: "bold",
                textTransform: "uppercase",
                marginBottom: "10px",
              }}
            >
              {status.replace("_", " ")}
            </div>
            {email_sent && (
              <div style={{ fontSize: "12px", color: "#666" }}>
                Email sent: {formattedDateTime(email_sent_at)}
              </div>
            )}
          </div>
        </div>

        {/* Hotel and Bill To Section */}
        <div className="row" style={{ marginBottom: "30px" }}>
          <div className="col-md-6">
            {hotelDetails ? (
              <div style={{ fontSize: "14px", lineHeight: "1.8" }}>
                <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                  {hotelDetails.name || "Hotel Name"}
                </div>
                <div>Address: {hotelDetails.address || "Address not available"}</div>
                {hotelDetails.city && <div>City: {hotelDetails.city}</div>}
                {hotelDetails.country && <div>Country: {hotelDetails.country}</div>}
                <div>Phone: {hotelDetails.phone || "+91 XXXXXXXXXX"}</div>
                <div>Email: {hotelDetails.email || "hotel@example.com"}</div>
                {hotelDetails.logo && (
                  <div>
                    <img
                      src={hotelDetails.logo}
                      alt="Hotel Logo"
                      style={{ width: "100px", marginTop: "10px" }}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div>Loading hotel info...</div>
            )}

          </div>
          <div className="col-md-6">
            <div style={{ fontSize: "14px", lineHeight: "1.8" }}>
              <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                Bill To:
              </div>
              <div>Guest Name: {`${first_name} ${last_name}`}</div>
              <div>Guest Phone: {phone}</div>
              <div>Booking Type: {reservation.booking_type.toUpperCase()}</div>
              <div>Purpose: {reservation.purpose_of_visit}</div>
              <div>Total Rooms: {reservation.total_rooms}</div>
              <div>
                Check-in: {formattedDateTime(reservation.check_in_date_time)}
              </div>
              <div>
                Check-out: {formattedDateTime(reservation.check_out_date_time)}
              </div>
              {reservation.remarks && <div>Remarks: {reservation.remarks}</div>}
            </div>
          </div>
        </div>

        {/* Separator Line */}
        <div
          className="separator-line"
          style={{ borderTop: "2px solid #000", margin: "30px 0" }}
        ></div>

        {/* Items Table */}
        <table
          className="invoice-table"
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "30px",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "12px",
                  backgroundColor: "#f8f9fa",
                  fontWeight: "bold",
                }}
              >
                Description
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "12px",
                  backgroundColor: "#f8f9fa",
                  fontWeight: "bold",
                  textAlign: "center",
                  width: "80px",
                }}
              >
                Qty
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "12px",
                  backgroundColor: "#f8f9fa",
                  fontWeight: "bold",
                  textAlign: "right",
                  width: "100px",
                }}
              >
                Rate
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "12px",
                  backgroundColor: "#f8f9fa",
                  fontWeight: "bold",
                  textAlign: "right",
                  width: "100px",
                }}
              >
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {/* Room Charges */}
            {reservation.room_details &&
              reservation.room_details.map((room, index) => {
                // Calculate room rate based on subtotal divided by total rooms and nights
                const totalRoomAmount =
                  Number.parseFloat(subtotal) -
                  (reservation.services
                    ? reservation.services.reduce(
                      (sum, service) =>
                        sum + Number.parseFloat(service.package_price || 0),
                      0
                    )
                    : 0);
                const roomRate =
                  totalRoomAmount / reservation.rooms.length / nights || 0;
                const roomAmount = roomRate * nights;

                return (
                  <tr key={index}>
                    <td style={{ border: "1px solid #000", padding: "12px" }}>
                      Room {room.room_number} ({room.room_type}) - {nights} night(s)
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "12px",
                        textAlign: "center",
                      }}
                    >
                      {nights}
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "12px",
                        textAlign: "right",
                      }}
                    >
                      ₹{roomRate.toFixed(2)}
                    </td>
                    <td
                      style={{
                        border: "1px solid #000",
                        padding: "12px",
                        textAlign: "right",
                      }}
                    >
                      ₹{roomAmount.toFixed(2)}
                    </td>
                  </tr>
                );
              })}

            {/* Services */}
            {reservation.package_names &&
              reservation.package_names.length > 0 &&
              reservation.package_names.map((service, index) => (
                <tr key={`service-${index}`}>
                  <td style={{ border: "1px solid #000", padding: "12px" }}>
                    {service.name || `Package ${reservation.services}`}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "12px",
                      textAlign: "center",
                    }}
                  >
                    1
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "12px",
                      textAlign: "right",
                    }}
                  >
                    ₹{Number.parseFloat(service.price || 0).toFixed(2)}
                  </td>
                  <td
                    style={{
                      border: "1px solid #000",
                      padding: "12px",
                      textAlign: "right",
                    }}
                  >
                    ₹{Number.parseFloat(service.price || 0).toFixed(2)}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>

        {/* Summary Section */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "30px",
          }}
        >
          <table
            className="summary-table"
            style={{ width: "300px", borderCollapse: "collapse" }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    padding: "8px 15px",
                    textAlign: "left",
                    fontWeight: "bold",
                  }}
                >
                  Subtotal:
                </td>
                <td style={{ padding: "8px 15px", textAlign: "right" }}>
                  ₹{Number.parseFloat(subtotal).toFixed(2)}
                </td>
              </tr>
              {Number.parseFloat(tax_amount) > 0 && (
                <tr>
                  <td
                    style={{
                      padding: "8px 15px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    Tax:
                  </td>
                  <td style={{ padding: "8px 15px", textAlign: "right" }}>
                    ₹{Number.parseFloat(tax_amount).toFixed(2)}
                  </td>
                </tr>
              )}
              {Number.parseFloat(discount_amount) > 0 && (
                <tr>
                  <td
                    style={{
                      padding: "8px 15px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    Discount:
                  </td>
                  <td style={{ padding: "8px 15px", textAlign: "right" }}>
                    -₹{Number.parseFloat(discount_amount).toFixed(2)}
                  </td>
                </tr>
              )}
              <tr
                className="summary-line"
                style={{ borderTop: "1px solid #000" }}
              >
                <td
                  style={{
                    padding: "8px 15px",
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  Total:
                </td>
                <td
                  style={{
                    padding: "8px 15px",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  ₹{Number.parseFloat(total_amount).toFixed(2)}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    padding: "8px 15px",
                    textAlign: "left",
                    fontWeight: "bold",
                  }}
                >
                  Paid:
                </td>
                <td style={{ padding: "8px 15px", textAlign: "right" }}>
                  ₹{Number.parseFloat(paid_amount).toFixed(2)}
                </td>
              </tr>
              <tr style={{ borderTop: "1px solid #000" }}>
                <td
                  style={{
                    padding: "8px 15px",
                    textAlign: "left",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  Balance:
                </td>
                <td
                  style={{
                    padding: "8px 15px",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  ₹{Number.parseFloat(balance_amount).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Notes Section */}
        {notes && (
          <div
            style={{
              marginTop: "30px",
              padding: "15px",
              backgroundColor: "#f8f9fa",
              borderRadius: "4px",
            }}
          >
            <strong>Notes:</strong>
            <div style={{ marginTop: "5px" }}>{notes}</div>
          </div>
        )}

        {/* Additional Information */}
        <div
          style={{
            marginTop: "30px",
            fontSize: "12px",
            color: "#666",
            borderTop: "1px solid #eee",
            paddingTop: "15px",
          }}
        >
          <div className="row">
            <div className="col-md-6">
              <div>
                Booking Status: {reservation.booking_status.toUpperCase()}
              </div>
              <div>Created: {formattedDateTime(reservation.created_at)}</div>
            </div>
            <div className="col-md-6 text-end">
              <div>
                Invoice Created: {formattedDateTime(invoiceData.created_at)}
              </div>
              {reservation.reason && <div>Reason: {reservation.reason}</div>}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            marginTop: "40px",
            textAlign: "center",
            fontSize: "14px",
            color: "#666",
          }}
        >
          <p>Thank you for your business!</p>
        </div>
      </div>
    </div >
  );
}

export default HotelInvoice;
